/* ==============================================================================================
 * TOGGLER COMPONENT
 * ============================================================================================== */

var Sushi;

(function (Sushi) {
	"use strict";

	var triggers = document.querySelectorAll("[data-feature=Toggler]");

	if (!triggers) {
		return;
	}

	Sushi.Dom.forEach(triggers, function (trigger) {
		var target = document.querySelector(trigger.getAttribute("data-toggler-target"));
		var isOpen = false;
		var activeClass = trigger.getAttribute("data-toggler-active-class");

		trigger.classList.add("c-toggler__trigger");
		target.classList.add("c-toggler__target");

		/**
		 * @return {void}
		 */
		function open() {
			trigger.classList.add(activeClass);
			target.classList.add(activeClass);
			isOpen = true;
		}

		/**
		 * @return {void}
		 */
		function close() {
			trigger.classList.remove(activeClass);
			target.classList.remove(activeClass);
			isOpen = false;
		}

		/**
		 * @return {void}
		 */
		function toggle() {
			isOpen ? close() : open();
		}

		Sushi.Events(window).on("click", function (event) {
			if (trigger.contains(event.target)) {
				toggle();
			}

			else if (!trigger.contains(event.target) && !target.contains(event.target)) {
				close();
			}
		});
	});

})(Sushi || (Sushi = {}));
